export const REORDER_CEILING = 500;

export function canHandReorder({ count, isSmart, canEdit }: { count: number; isSmart: boolean; canEdit: boolean }): boolean {
  return !isSmart && canEdit && count >= 2 && count <= REORDER_CEILING;
}
